import { useEffect } from "react";

/**
 * AccessibilityRoot — hydrates accessibility prefs from localStorage onto
 * <html data-attrs> on every rider-app mount. The /preferences/accessibility
 * page writes there but until a user visits that page, this component is
 * what carries their last choice across reloads.
 *
 * Renders nothing.
 */
export default function AccessibilityRoot() {
  useEffect(() => {
    const root = document.documentElement;
    try {
      const ts = localStorage.getItem("link.a11y.text-size");
      if (ts === "large" || ts === "xlarge") root.setAttribute("data-text-size", ts);
      const rm = localStorage.getItem("link.a11y.reduced-motion");
      if (rm === "1") root.setAttribute("data-reduced-motion", "1");
    } catch (_) {}
  }, []);
  return null;
}
